import angular from 'angular';
import linkGmailSyncModal from './linkGmailSyncModal';

export default angular
  .module('components.linkGmailSyncModal', [])
  .component('linkGmailSyncModal', linkGmailSyncModal).name;
